export const NOTIFICATION_STATUS_TYPE = {
  unread: 0,
  read: 1
} as const

type NotificationStatusType = typeof NOTIFICATION_STATUS_TYPE
export type NotificationStatusTypes = NotificationStatusType[keyof NotificationStatusType]
